export interface Banner {
  id: string;
  title: string;
  image: string;
  active: boolean;
  updated: string;
}

export const banners: Banner[] = [
  {
    id: 'bn1',
    title: 'Banner chào mừng thành viên mới',
    image: 'https://readdy.ai/api/search-image?query=Wide%20promotional%20banner%20with%20golden%20gold%20bars%20on%20dark%20black%20background%2C%20luxury%20financial%20promotion%2C%20warm%20golden%20lighting%2C%20premium%20elegant%20style&width=1200&height=400&seq=banner-gold-1&orientation=landscape',
    active: true,
    updated: '12/08/2026',
  },
  {
    id: 'bn2',
    title: 'Banner ưu đãi phí giao dịch',
    image: 'https://readdy.ai/api/search-image?query=Dark%20elegant%20promotion%20banner%20with%20golden%20coins%20and%20graph%20rising%2C%20black%20and%20gold%20color%20scheme%2C%20luxury%20financial%20offer%2C%20clean%20modern%20design&width=1200&height=400&seq=banner-gold-2&orientation=landscape',
    active: false,
    updated: '10/08/2026',
  },
];

export interface AdminLog {
  id: string;
  admin: string;
  action: string;
  target: string;
  ip: string;
  time: string;
}

export const adminLogs: AdminLog[] = [
  { id: 'l1', admin: 'Admin', action: 'Duyệt yêu cầu nạp tiền', target: 'Lê Hoàng Minh - 350.000.000đ', ip: '118.70.x.x', time: '14/08/2026 16:20' },
  { id: 'l2', admin: 'Admin', action: 'Từ chối yêu cầu rút tiền', target: 'Phạm Quốc Bảo - 30.000.000đ', ip: '118.70.x.x', time: '13/08/2026 14:00' },
  { id: 'l3', admin: 'Admin', action: 'Khóa tài khoản', target: 'Phạm Quốc Bảo', ip: '118.70.x.x', time: '13/08/2026 14:05' },
  { id: 'l4', admin: 'Admin', action: 'Cập nhật banner', target: 'Banner chào mừng thành viên mới', ip: '118.70.x.x', time: '12/08/2026 09:30' },
  { id: 'l5', admin: 'Admin', action: 'Đăng tin tức mới', target: 'Giá vàng thế giới tăng mạnh', ip: '118.70.x.x', time: '12/08/2026 08:15' },
];